import classNames from 'classnames';
import React from 'react';

import { PageLayoutHeader, type PageLayoutHeaderProps } from './PageLayoutHeader';

import './TablePageLayout.scss';

interface TablePageLayoutProps extends PageLayoutHeaderProps {
	/** Content rendered above the table (e.g., filters, search, action buttons) */
	aboveTableContent?: React.ReactNode;
	/** The main table content */
	tableContent: React.ReactNode;
	/** Content rendered below the table (e.g., pagination) */
	belowTableContent?: React.ReactNode;
	/** Optional class name for custom styling */
	className?: string;
}

/**
 * Layout component for pages with tables.
 * Provides consistent structure for above-table controls, table content, and below-table elements.
 */
export const TablePageLayout: React.FC<TablePageLayoutProps> = ({
	title,
	breadcrumb,
	size = 'heading',
	aboveTableContent,
	tableContent,
	belowTableContent,
	className,
}) => {
	const pageLayoutHeader =
		title || breadcrumb ? (
			<PageLayoutHeader title={title} breadcrumb={breadcrumb} size={size} />
		) : null;

	return (
		<div className={classNames('table-page-layout', className)}>
			{(pageLayoutHeader || aboveTableContent) && (
				<div className='table-page-layout__above'>
					{pageLayoutHeader}
					{aboveTableContent}
				</div>
			)}
			<div className='table-page-layout__table'>{tableContent}</div>
			{belowTableContent && (
				<div className='table-page-layout__below'>{belowTableContent}</div>
			)}
		</div>
	);
};
